import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate} from "remotion";
import {loadDefaultFonts} from "../../presets/fonts";

export interface BeforeAfterProps {
  beforeLabel?: string;
  afterLabel?: string;
  beforeColor?: string;
  afterColor?: string;
  backgroundColor?: string;
  accentColor?: string;
  children: [React.ReactNode, React.ReactNode];
}

export const BeforeAfter: React.FC<BeforeAfterProps> = ({
  beforeLabel = "Before",
  afterLabel = "After",
  beforeColor = "#ef4444",
  afterColor = "#10b981",
  backgroundColor = "#0a0a0a",
  accentColor = "#ffffff",
  children,
}) => {
  const frame = useCurrentFrame();
  const {durationInFrames} = useVideoConfig();
  loadDefaultFonts();

  // Wipe transition at midpoint
  const midpoint = Math.floor(durationInFrames / 2);
  const wipeProgress = interpolate(
    frame,
    [midpoint - 15, midpoint + 15],
    [0, 100],
    {extrapolateLeft: "clamp", extrapolateRight: "clamp"},
  );

  return (
    <AbsoluteFill style={{backgroundColor}}>
      {/* Before */}
      <AbsoluteFill
        style={{
          clipPath: `inset(0 ${wipeProgress}% 0 0)`,
        }}
      >
        {children[0]}
        <div
          style={{
            position: "absolute",
            top: 40,
            left: 40,
            backgroundColor: beforeColor,
            color: accentColor,
            padding: "8px 20px",
            borderRadius: 8,
            fontSize: 20,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 2,
          }}
        >
          {beforeLabel}
        </div>
      </AbsoluteFill>

      {/* After */}
      <AbsoluteFill
        style={{
          clipPath: `inset(0 0 0 ${100 - wipeProgress}%)`,
        }}
      >
        {children[1]}
        <div
          style={{
            position: "absolute",
            top: 40,
            right: 40,
            backgroundColor: afterColor,
            color: accentColor,
            padding: "8px 20px",
            borderRadius: 8,
            fontSize: 20,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 2,
          }}
        >
          {afterLabel}
        </div>
      </AbsoluteFill>

      {/* Divider line */}
      {wipeProgress > 0 && wipeProgress < 100 && (
        <div
          style={{
            position: "absolute",
            left: `${100 - wipeProgress}%`,
            top: 0,
            bottom: 0,
            width: 3,
            backgroundColor: accentColor,
            boxShadow: "0 0 20px rgba(255,255,255,0.5)",
          }}
        />
      )}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
